import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import(/* webpackChunkName: "root" */ '../views/Index.vue')
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/auth/Login.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "../views/auth/ForgotPassword.vue"
      ),
  },
  {
    path: "/recover-account/:token",
    name: "recover-account",
    component: () =>
      import(
        /* webpackChunkName: "recover-account" */ "../views/auth/RecoverAccount.vue"
      ),
  },
  {
    path: "/dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () =>
          import(
            /* webpackChunkName: "dashboard.index" */ "../views/dashboard/Index.vue"
          ),
      },
      {
        path: "request-loan",
        component: () =>
          import(
            /* webpackChunkName: "dashboard.request-loan" */ "../views/dashboard/RequestLoan.vue"
          ),
        children: [
          {
            path: "",
            name: "request-loan",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.request-loan" */ "../views/dashboard/request-loan/Index.vue"
              ),
          },
          {
            path: ":id",
            name: "request-loan.create",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.request-loan" */ "../views/dashboard/request-loan/Create.vue"
              ),
          },
        ],
      },
      {
        path: "loans",
        component: () =>
          import(
            /* webpackChunkName: "dashboard.loans" */ "../views/dashboard/Loans.vue"
          ),
        children: [
          {
            path: "",
            name: "loans",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.loans" */ "../views/dashboard/loans/Index.vue"
              ),
          },
          {
            path: "history",
            name: "loans.history",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.loans" */ "../views/dashboard/loans/History.vue"
              ),
          },
          {
            path: "payment",
            name: "loans.payment",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.loans" */ "../views/dashboard/loans/Payment.vue"
              ),
          },
          {
            path: ":id",
            name: "loans.show",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.loans" */ "../views/dashboard/loans/Show.vue"
              ),
          },
        ],
      },
      {
        path: "contributions",
        component: () =>
          import(
            /* webpackChunkName: "dashboard.contributions" */ "../views/dashboard/Contributions.vue"
          ),
        children: [
          {
            path: "",
            name: "contributions",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.contributions" */ "../views/dashboard/contributions/Index.vue"
              ),
          },
          {
            path: "create",
            name: "contributions.create",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.contributions" */ "../views/dashboard/contributions/Create.vue"
              ),
          },
          {
            path: ":id",
            name: "contributions.show",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.contributions" */ "../views/dashboard/contributions/Show.vue"
              ),
          },
        ],
      },
      {
        path: "my-account",
        component: () =>
          import(
            /* webpackChunkName: "dashboard.my-account" */ "../views/dashboard/MyAccount.vue"
          ),
        children: [
          {
            path: "",
            name: "my-account",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.my-account" */ "../views/dashboard/my-account/Index.vue"
              ),
          },
          {
            path: "personal-info",
            name: "my-account.personal-info",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.personal-info" */ "../views/dashboard/my-account/personal-info/Index.vue"
              ),
          },
          {
            path: "personal-info/edit",
            name: "my-account.personal-info.edit",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.personal-info" */ "../views/dashboard/my-account/personal-info/Edit.vue"
              ),
          },
          {
            path: "contact-info",
            name: "my-account.contact-info",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.contact-info" */ "../views/dashboard/my-account/contact-info/Index.vue"
              ),
          },
          {
            path: "contact-info/edit",
            name: "my-account.contact-info.edit",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.contact-info" */ "../views/dashboard/my-account/contact-info/Edit.vue"
              ),
          },
          {
            path: "next-of-kin",
            name: "my-account.next-of-kin",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.next-of-kin" */ "../views/dashboard/my-account/next-of-kin/Index.vue"
              ),
          },
          {
            path: "next-of-kin/edit",
            name: "my-account.next-of-kin.edit",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.next-of-kin" */ "../views/dashboard/my-account/next-of-kin/Edit.vue"
              ),
          },
          {
            path: "beneficiaries",
            name: "my-account.beneficiaries",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.beneficiaries" */ "../views/dashboard/my-account/beneficiaries/Index.vue"
              ),
          },
          {
            path: "beneficiaries/edit",
            name: "my-account.beneficiaries.edit",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.beneficiaries" */ "../views/dashboard/my-account/beneficiaries/Edit.vue"
              ),
          },
          {
            path: "documents",
            name: "my-account.documents",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.documents" */ "../views/dashboard/my-account/documents/Index.vue"
              ),
          },
          {
            path: "documents/edit",
            name: "my-account.documents.edit",
            component: () =>
              import(
                /* webpackChunkName: "dashboard.documents" */ "../views/dashboard/my-account/documents/Edit.vue"
              ),
          },
        ],
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
